export default {
  init(element) {
    const $fundsCarousel = $(element).find('.funds-carousel .carousel');
    const fundsCarouselFlickity = $fundsCarousel.flickity({
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: false,
    });

    const $fundCarouselControlPrev = $(element).find('.fund-progress-controls .fund-carousel-control-prev');
    $fundCarouselControlPrev.on('click', function () {
      fundsCarouselFlickity.flickity('previous');
    });

    const $fundCarouselControlNext = $(element).find('.fund-progress-controls .fund-carousel-control-next');
    $fundCarouselControlNext.on('click', function () {
      fundsCarouselFlickity.flickity('next');
    });

    const $fundCarouselProgressBar = $(element).find('.funds-carousel-progress .funds-carousel-progress-bar');
    $fundsCarousel.on('scroll.flickity', function (event, progress) {
      progress = Math.max(0, Math.min(1, progress));

      // Update progress bar width depending on progress
      $fundCarouselProgressBar.css('width', `${progress * 100}%`);

      // Disable buttons depending on progress
      if (progress <= 0) {
        $fundCarouselControlPrev.addClass('disabled');
        $fundCarouselControlPrev.prop('disabled', true);
      } else {
        $fundCarouselControlPrev.removeClass('disabled');
        $fundCarouselControlPrev.prop('disabled', false);
      }

      if (progress >= 1) {
        $fundCarouselControlNext.addClass('disabled');
        $fundCarouselControlNext.prop('disabled', true);
      } else {
        $fundCarouselControlNext.removeClass('disabled');
        $fundCarouselControlNext.prop('disabled', false);
      }
    });
  },
  finalize(element) { },
}


// WEBPACK FOOTER //
// ./scripts/routes/flexible-contents/flexibleContentFeaturedFundsSlider.js